import { useRef } from 'react'
import { MobileContentGems } from '@mc/api'
import { trackSkillsYoullLearnViewed } from '../../../events'
import { useStickyCardsStack } from '../../../hooks/useStickyCardsStack'
import { StickyCardMobile } from './StickyCard'
import styles from './StickyCard/StickyCard.module.scss'

export const ContentMobile = ({
  mobileContentGems,
}: {
  mobileContentGems: MobileContentGems[]
}) => {
  const cardRefs = useRef<(HTMLDivElement | null)[]>([])
  const containerRef = useRef<HTMLDivElement | null>(null)

  const { isStacked, dynamicHeight } = useStickyCardsStack({
    mobileContentGems,
    cardRefs,
    containerRef,
    overlayClass: styles.overlay,
  })

  const setCardRef = (index: number) => (el: HTMLDivElement | null) => {
    cardRefs.current[index] = el
  }

  const handleCardViewed = (gem: MobileContentGems, index: number) => () => {
    trackSkillsYoullLearnViewed({
      location: index,
      cardTitle: gem.title,
    })
  }

  return (
    <div
      ref={containerRef}
      className='row no-gutters'
      style={{
        margin: -8,
        height: dynamicHeight,
        position: isStacked ? 'relative' : 'initial',
      }}
    >
      {mobileContentGems.map((gem, index) => {
        const isLastCard = index === mobileContentGems.length - 1

        return (
          <StickyCardMobile
            key={gem.id}
            gem={gem}
            index={index}
            isLastCard={isLastCard}
            cardRef={setCardRef(index)}
            onCardViewed={handleCardViewed(gem, index)}
            isStacked={isStacked}
          />
        )
      })}
    </div>
  )
}
